<template>
  <div class="guest-b" :class="data.items.length > 1 ? 'normal' : 'single'">
    <template v-for="(item, i) in data.items">
      <div class="item" :class="{'has-pointer': Number(aid) === 113 || Number(aid) === 122 || item.content.link}" :key="`${item.sort}-${i}`" @click="setLink(item, i)">
        <div class="topic" v-if="item.content.topic">
          {{item.content.topic}}
        </div>
        <div class="item-top" 
          :class="{'hastopic': item.content.topic}"
        >
          <div class="img-head" v-if="aid === 'preview' ? item.content.avatar && item.content.avatar.url : item.content.avatar">
            <div class="img" :style="{'background-image': `url(${item.content.avatar.url || item.content.avatar})`}"></div>
          </div>
          <div class="person-msg">
            <div class="name">{{item.content.name}}</div>
            <div class="title">{{item.content.title}}</div>
          </div>
        </div>
        <div class="desc" v-if="item.content.desc">{{item.content.desc}}</div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'e-guest-b',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      aid: this.$route.query.id,
      links: ['https://qcon.infoq.cn/2020/beijing/?utm_source=infoq&utm_medium=landingpage&utm_campaign=mar',
        'https://archsummit.infoq.cn/2020/shenzhen/?utm_source=infoq&utm_medium=landingpage&utm_campaign=mar',
        'https://gmtc.infoq.cn/2020/beijing/?utm_source=infoq&utm_medium=landingpage&utm_campaign=mar',
        'https://aicon.infoq.cn/2020/shanghai/?utm_source=infoq&utm_medium=landingpage&utm_campaign=mar',
        'https://pcon.infoq.cn/2020/beijing/?utm_source=infoq&utm_medium=landingpage&utm_campaign=mar',
        'https://gtlc.infoq.cn/2020/beijing/?utm_source=infoq&utm_medium=landingpage&utm_campaign=mar'
      ],
      links122: [
        'https://qcon.infoq.cn/2020/beijing/?utm_source=infoq&utm_medium=talc&utm_campaign=may&utm_term=0422',
        'https://archsummit.infoq.cn/2020/shenzhen/?utm_source=infoq&utm_medium=talc&utm_campaign=may&utm_term=0422',
        'https://gmtc.infoq.cn/2020/beijing/?utm_source=infoq&utm_medium=talc&utm_campaign=may&utm_term=0422',
        'https://aicon.infoq.cn/2020/shanghai/?utm_source=infoq&utm_medium=talc&utm_campaign=may&utm_term=0422',
        'https://pcon.infoq.cn/2020/beijing/?utm_source=infoq&utm_medium=talc&utm_campaign=may&utm_term=0422',
        'https://gtlc.infoq.cn/2020/beijing?utm_source=infoq&utm_medium=talc&utm_campaign=may&utm_term=0422'
      ]
    }
  },
  created () {
  },
  methods: {
    setLink (item, i) {
      let link = ''
      if (Number(this.aid) === 113) {
        link = this.links[i]
        link && window.open(link, '_blank')
      } else if (Number(this.aid) === 122) {
        link = this.links122[i]
        link && window.open(link, '_blank')
      } else {
        if (item.content.link) {
          window.open(item.content.link, '_blank')
        } else {
          return false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/common';

.guest-b {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  &.single {
    justify-content: center;
  }

  & .item {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-bottom: 30px;
    width: 353px;
    background: #fff;
    border: 1px solid $grayBorder;
    border-radius: 4px;

    &.has-pointer {
      cursor: pointer;
    }

    & .topic {
      margin: 0 14px 0 9px;
      padding: 20px 8px 15px 8px;
      border-bottom: 1px solid $grayBorder;
      color: #303030;
      @include lineFont(16, 600);
      // @extend %row;
    }

    & .item-top {
      display: flex;
      align-items: center;
      padding: 28px 20px 0;
      margin-bottom: 28px;

      &.hastopic {
        padding-top: 18px;
      }

      & .img-head {
        margin-right: 18px;
      }

      & .person-msg {
        // margin-left: 18px;
        & .name {
          @include font(16, 600);
          color: $lightBlack;
        }

        & .title {
          line-height: 21px;
          @include font(14, 400);
          color: $gray;
          // @include row(2);
        }
      }

      & .img-head {
        flex: none;
        width: 79px; height: 79px;
        background: #fff;
        border: 1px solid $blue;
        border-radius: 50%;

        & .img {
          width: 100%; height: 100%;
          background-size: cover;
          background-position: center center;
          box-sizing: border-box;
          border: 3px solid #fff;
          border-radius: 50%;
        }
      }
    }

    & .desc {
      margin-top: -14px;
      padding: 0 20px 24px;
      text-align: justify;
      line-height: 24px;
      @include font(16, 400);
      color: $lightBlack;
      white-space: pre-wrap;
    }
  }
}

@media screen and (max-width: 768px) {
  .guest-b {
    padding: 0 20px;

    & .item {
      width: 100%;
      margin-bottom: 12px;

      & .name {
        padding-top: 2px;
      }
    }
  }
}
</style>
